<p-panel *ngFor="let notification of notificationMaintenance" styleClass="p-panel-whitebg mb-3">
   <ng-template pTemplate="header">
      <div class="font-semibold text-medium text-lg">{{notification.Title}}</div>
   </ng-template>
   <div [innerHTML]="notification.Text">
   </div>
</p-panel>
<div class="grid mt-3 mb-1 mx-1 flex justify-content-center align-items-center">
   <button type="button" pButton pRipple (click)="closeDialog()"
      label="{{ 'CLOSE' | translate }}"
      class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1"
      [ngClass]="dynamicButtonWidth()">
   </button>
</div>